export default "__VITE_ASSET__BKdt_7CS__"